import { lazy, ComponentType } from "react";
import { trackForcedReload } from "./trackNavigation";

const RELOAD_TS_KEY = "chunk-reload-ts";
const RELOAD_COOLDOWN_MS = 10000;

// Протухший чанк после деплоя: динамический import отсутствующего хеша падает
// (SyntaxError от HTML-фолбэка сервера или "Failed to fetch dynamically imported
// module"). Один раз перезагружаем страницу, чтобы получить свежий index.html с
// актуальными хешами. Кулдаун по таймстампу защищает от цикла, если чанк реально
// битый — тогда ошибка уходит в ErrorBoundary.
export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch(error => {
      const now = Date.now()
      const last = Number(sessionStorage.getItem(RELOAD_TS_KEY) || 0)

      if (now - last > RELOAD_COOLDOWN_MS) {
        sessionStorage.setItem(RELOAD_TS_KEY, String(now))
        trackForcedReload("lazy_chunk_load_failed", { error })
        window.location.reload()
        // Вечный промис: не даём Suspense отрендерить ошибку до перезагрузки.
        return new Promise<{ default: T }>(() => {})
      }

      throw error
    })
  )
}
